import { useEffect, useState } from 'react';
import EmbedWidget from './EmbedWidget';
import { useSearchParams } from 'react-router-dom';

export default function EmbedPage() {
  const [searchParams] = useSearchParams();
  const [flowDefinition, setFlowDefinition] = useState<any>(null);

  useEffect(() => {
    // Prova a caricare flowDefinition da URL params
    const flowParam = searchParams.get('flow');
    if (flowParam) {
      try {
        const decoded = JSON.parse(decodeURIComponent(flowParam));
        setFlowDefinition(decoded);
      } catch (e) {
        console.error('Errore parsing flow da URL:', e);
      }
    }

    // Ascolta messaggi dal parent window
    const handleMessage = (event: MessageEvent) => {
      // Verifica origin per sicurezza (permetti solo domini autorizzati)
      const allowedOrigins = [
        'https://www.lmreal-estate.it',
        'https://lmreal-estate.it',
        'http://localhost',
        'http://127.0.0.1',
        window.location.origin, // Permetti anche il dominio corrente
      ];
      
      const isAllowed = allowedOrigins.some(origin => 
        event.origin === origin || event.origin.startsWith(origin)
      );
      
      if (isAllowed && event.data.type === 'pigna-flow-definition') {
        setFlowDefinition(event.data.flowDefinition);
      }
    };

    window.addEventListener('message', handleMessage);
    return () => window.removeEventListener('message', handleMessage);
  }, [searchParams]);

  // Estrai parametri opzionali
  const title = searchParams.get('title') || 'Chat Assistant';
  const primaryColor = searchParams.get('color') || '#9333ea';
  const height = searchParams.get('height') || '600px';
  const apiUrl = searchParams.get('apiUrl') || undefined;
  const theme = (searchParams.get('theme') as 'light' | 'dark' | 'auto') || 'light';
  const animation = (searchParams.get('animation') as 'slide' | 'fade' | 'bounce' | 'none') || 'slide';
  const customCSS = searchParams.get('customCSS') ? decodeURIComponent(searchParams.get('customCSS')!) : undefined;

  return (
    <div style={{ width: '100vw', height: '100vh', margin: 0, padding: 0 }}>
      <EmbedWidget
        flowDefinition={flowDefinition}
        title={title}
        primaryColor={primaryColor}
        height={height}
        apiUrl={apiUrl}
        theme={theme}
        animation={animation}
        customCSS={customCSS}
      />
    </div>
  );
}

